export default "__VITE_ASSET__cqNMWeyv__"